import React, { useEffect, useState } from 'react';
import { Box, LinearProgress, CircularProgress } from '@mui/material';
import { aiActivity } from 'utils/aiActivity';

/**
 * Global "Key is working…" indicator, fixed to the top of the viewport so it shows on EVERY
 * page and device — independent of the chat widget or the current screen. This covers the
 * case where Key builds a report and then navigates the user (take_me_there / self-navigating
 * report tools): the report page's own spinner isn't on screen yet, so without this the user
 * sees a silent 30–45s stall. Driven by in-flight POST /AI calls via aiActivity.
 */
export default function GlobalAiActivity() {
  const [busy, setBusy] = useState(aiActivity.isBusy());
  useEffect(() => {
    setBusy(aiActivity.isBusy()); // resync in case it changed before we subscribed
    return aiActivity.subscribe(setBusy);
  }, []);

  if (!busy) return null;

  return (
    <>
      <LinearProgress
        aria-hidden
        sx={{ position: 'fixed', top: 0, left: 0, right: 0, height: 3, zIndex: 2000 }}
      />
      <Box
        role='status'
        aria-live='polite'
        sx={{
          position: 'fixed', top: 10, left: '50%', transform: 'translateX(-50%)', zIndex: 2001,
          display: 'flex', alignItems: 'center', gap: 1,
          bgcolor: 'rgba(0, 0, 0, 0.78)', color: '#fff',
          px: 1.5, py: 0.5, borderRadius: 2, fontSize: 13, boxShadow: 3,
          pointerEvents: 'none', userSelect: 'none', whiteSpace: 'nowrap',
        }}
      >
        <CircularProgress size={14} thickness={5} sx={{ color: '#fff' }} />
        Key is working…
      </Box>
    </>
  );
}
